import React from "react";
import CreateReports from "../components/reports/create_reports";

const CreateReportIlyas = () => {
    return <CreateReports update={"fenix"} sim={"Fenix"} team={"fenix"} />
}

export default CreateReportIlyas